module.exports = __webpack_public_path__ + "static/media/carriedDrill.5b6aa2e8.png";